import {call, put,takeLatest} from 'redux-saga/effects'
import * as cartService from "../../../services/cartService"
import {
    REPEAT_ORDER,
    REPEAT_ORDER_SUCCESS,
    REPEAT_ORDER_ERROR
}
    from "../../actions/cart";

function* repeatOrderSaga(action) {
    try {
        const data=yield call(cartService.RepeatOrder,action.payload)
        yield put({
            type: REPEAT_ORDER_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: REPEAT_ORDER_ERROR,error: error.data
        });
    }
}


export function* repeatOrderSagaWatcher() {
    yield takeLatest(REPEAT_ORDER,repeatOrderSaga);
}